import React from "react";
import UserRoutes from "./routes/UserRotes";

function App() {
  return <UserRoutes />;
}

export default App;
